module.exports = __webpack_public_path__ + "static/img/indexDot.bf67f70a.png";